// Sistema de eventos para manejar sesión expirada
class SessionManager {
    constructor() {
        this.listeners = [];
    }

    // Agregar listener para sesión expirada
    onSessionExpired(callback) {
        this.listeners.push(callback);
    }

    // Notificar a todos los listeners que la sesión expiró
    notifySessionExpired() {
        this.listeners.forEach(callback => callback());
    }

    // Limpiar listeners
    clearListeners() {
        this.listeners = [];
    }
}

// Instancia singleton
const sessionManager = new SessionManager();

export default sessionManager;
